export default {
  setData: (state, citizenReportsCategories) => {
    state.citizenReportsCategories = [...citizenReportsCategories]
  },

  toggleModal(state, val) {
    state.manageModal = val
  },
}
